import React from 'react'
import { Link } from 'react-router'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { useSelector, useDispatch } from 'react-redux'
import exact from 'prop-types-exact'
import ArrowToggle from '../../components/util/ArrowToggle'
import { setShowBlacklistedPages } from '../../components/menu/menuActions'
import { refreshAllAds } from '../../ad/AlmaAd'
import { selectSideMenuLinks } from '../../selectors/menuSelectors'
import { selectLocationPath } from '../../selectors/statusSelector'
import { selectUserWhitelistedCategoryIds, selectUserBlacklistedCategoryIds } from '../../selectors/userSelector'
import { CATEGORY_ID_PAIKALLISUUTISET, CATEGORY_ID_URHEILU } from '../../lib/constants'

const LINK_SPORT_RESULTS = '/urheilu/tulospalvelu'

const SidebarMenuItem = ({
  menuLink,
  path,
  blacklistedCategoryIds,
  whitelistedCategoryIds,
  dispatch,
}) => {
  const hasSubPages = menuLink.pages && !menuLink.pages.isEmpty()
  const showBlacklistedPages = menuLink.showBlacklistedPages
  const isActive = menuLink.to === path
  const isBlacklisted = blacklistedCategoryIds.contains(menuLink.categoryId) || (blacklistedCategoryIds.contains(CATEGORY_ID_URHEILU) && menuLink.to === LINK_SPORT_RESULTS)
  const isWhitelisted = whitelistedCategoryIds.contains(menuLink.categoryId)
  const hasBlacklistedChildren = menuLink.pages &&
    (menuLink.categoryId === CATEGORY_ID_PAIKALLISUUTISET || menuLink.pages.some(subPage => blacklistedCategoryIds.has(subPage.categoryId)))

  const subMenuClasses = {
    'menu-list--show-non-blacklisted': hasSubPages && !showBlacklistedPages && menuLink.categoryId !== CATEGORY_ID_PAIKALLISUUTISET,
    'menu-list--show-only-whitelisted': hasSubPages && !showBlacklistedPages && menuLink.categoryId === CATEGORY_ID_PAIKALLISUUTISET,
  }

  const rowClasses = {
    'menu-item': true,
    'menu-item--active': isActive,
    'menu-item--blacklisted': isBlacklisted,
    'menu-item--whitelisted': isWhitelisted,
  }

  const handleShowBlacklistedPages = () => {
    dispatch(setShowBlacklistedPages(!showBlacklistedPages, menuLink.to))
  }

  const handleRefreshAdsIfOnSamePage = () => {
    if (menuLink.to === path) {
      refreshAllAds()
    }
  }

  return (
    <li className={ classnames(rowClasses) }>
      <div className='menu-item__row'>
        <Link className='menu-item__link' to={ menuLink.to } onClick={ handleRefreshAdsIfOnSamePage } >
          { menuLink.menuTitle }
        </Link>
        { hasBlacklistedChildren && (
          <ArrowToggle
            toggleUp={ showBlacklistedPages }
            onToggleAction={ handleShowBlacklistedPages }
            screenReaderMessage='Listaa alakategoriat'
          />
        ) }
      </div>

      { hasSubPages &&
        <SidebarMenuItems
          className={ classnames(subMenuClasses) }
          menuLinks={ menuLink.pages }
          path={ path }
          blacklistedCategoryIds={ blacklistedCategoryIds }
          whitelistedCategoryIds={ whitelistedCategoryIds }
          dispatch={ dispatch }
        />
      }
    </li>
  )
}

SidebarMenuItem.propTypes = exact({
  path: PropTypes.string.isRequired,
  blacklistedCategoryIds: ImmutablePropTypes.set.isRequired,
  whitelistedCategoryIds: ImmutablePropTypes.set.isRequired,
  dispatch: PropTypes.func.isRequired,
  menuLink: ImmutablePropTypes.record.isRequired,
})

const SidebarMenuItems = ({
  menuLinks,
  path,
  blacklistedCategoryIds,
  whitelistedCategoryIds,
  dispatch,
  className = '',
}) => (
  <ul className={ `menu-list ${className}` }>
    { menuLinks.map(menuLink => (
      <SidebarMenuItem
        key={ menuLink.get('to') }
        menuLink={ menuLink }
        path={ path }
        blacklistedCategoryIds={ blacklistedCategoryIds }
        whitelistedCategoryIds={ whitelistedCategoryIds }
        dispatch={ dispatch }
      />
    )) }
  </ul>
)

SidebarMenuItems.propTypes = exact({
  menuLinks: ImmutablePropTypes.list.isRequired,
  path: PropTypes.string.isRequired,
  blacklistedCategoryIds: ImmutablePropTypes.set.isRequired,
  whitelistedCategoryIds: ImmutablePropTypes.set.isRequired,
  dispatch: PropTypes.func.isRequired,
  className: PropTypes.string,
})

const SidebarMenuList = () => {
  const dispatch = useDispatch()
  const path = useSelector(selectLocationPath)
  const menuLinks = useSelector(selectSideMenuLinks)
  const blacklistedCategoryIds = useSelector(selectUserBlacklistedCategoryIds)
  const whitelistedCategoryIds = useSelector(selectUserWhitelistedCategoryIds)

  return (
    <SidebarMenuItems
      menuLinks={ menuLinks }
      path={ path }
      blacklistedCategoryIds={ blacklistedCategoryIds }
      whitelistedCategoryIds={ whitelistedCategoryIds }
      dispatch={ dispatch }
    />
  )
}

export default SidebarMenuList
